import { parseProductDataObj, pushSelectItem } from "../../../helpers/pushSelectItem";
import downloadLink from "./downloadLink";

const test = ({ target, link }) => {
  return !downloadLink.test({ link }) && (
    target.getAttribute("data-gtm-type") === "product_card" ||
    target.closest('[data-gtm-type="product_card"]')
  );
}

const push = ({ target }) => {
  const dataObj = parseProductDataObj(target, ".card__dataLayer");
  if (!dataObj.item_id) return;

  pushSelectItem(dataObj);
};

export default {
  name: "product_card",
  test,
  push,
};
